module.exports = __webpack_public_path__ + "img/potencia_c_blue.2d280138.svg";